import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { PeopleService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class PeopleBloc extends Bloc<PeopleService['personControllerGetOne']> {
    public constructor(service: PeopleService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.personControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
